import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchasesAdministrativeService {

  private URL = environment.api + "api/administrative/purchase/invoices";
    constructor(
      private http: HttpClient,
    ) { }

  postInvoice(invoiceData: any) {
    return this.http.post(this.URL, invoiceData);
  }
}
